<template>
  <div
    v-if="mainData.length != 0"
    id="advertise"
    class="topContainer"
  >
    <div
      v-for="(item, index) in mainData"
      :key="index"
      class="container"
    >
      <div class="mainWrap">
        <div
          class="mainItem"
          :class="index==mainData.length-1? 'downItem': ''"
        >
          <div class="title">
            {{ item.title }}
          </div>
          <div
            v-for="(image,img_index) in item.images"
            :key="img_index"
            class="wrap"
            @click="goto(image.link, item.title)"
          >
            <div class="image">
              <img
                :src="image.img_uri"
                alt="活動圖片"
              >
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { googleFormTransform } from '@/js/utils'
export default {
  data () {
    return {
      mainData: []
    }
  },
  mounted () {
    this.getData()
  },
  methods: {
    async getData () {
      const res = await this.$getAPI(`${process.env.VUE_APP_CORE_URL}/api/Banner/GetBanner`)
      this.mainData = res.reverse().map(el => {
        const { images } = el
        const newImages = images.map(image => {
          const processedUrl = googleFormTransform.fetchURL(image.link)
          return {
            ...image,
            link: processedUrl
          }
        })
        return {
          ...el,
          images: newImages
        }
      })
    },
    goto (url, title) {
      this.$sendGAEvent('廣告Banner點擊數', {
        value: `click_${title}_${url}`
      })
      window.open(url, '_blank')
    }
  }
}
</script>

<style lang="sass" scoped>
.topContainer
  background-color: $bgDarkBg
  border-radius: 8px
  .container
    display: flex
    box-sizing: border-box
    margin-left: auto
    margin-right: auto
    flex-direction: column
    width: 948px
    border-radius: 8px
    background-color: $bgDark4
    margin-top: 25px
    box-shadow: 0px 0px 5px 0px rgba(0,0,0,0.1)
  .mainItem
    margin-bottom: 28px
    font-size: 23px
    &.downItem
      margin-bottom: 22px
    .title
      margin-left: 20px
      margin-bottom: 15px
      font-size: 25px

  .mainWrap
    color: $mainFontColor
    margin-top: 20px
  .wrap
    margin-bottom: 25px
    // height: 200px
    cursor: pointer
  .word_block
    width: 65%
    background: $mainFontColor
    color: #fff
  .image
    width: 948px
    // height: 200px
    img
      width: 100%
      height: 100%
      object-fit: fill
      object-position: center
</style>
